import { WarehouseSizeModel } from "@app/client/warehouseSizeModel";
import ServiceBase from "@app/shared/serviceBase";

class SnowflakeService extends ServiceBase {
  /**
   * Gets all available Snowflake warehouse sizes.
   */
  public async getAppWarehouseSizeConfiguration(): Promise<WarehouseSizeModel> {
    return await this.makeGet<WarehouseSizeModel>("snowflake/warehouse-size-configuration");
  }
}

export { SnowflakeService };
